const { render, Component, Fragment } = wp.element;
const { getQueryArg, qs } = wp.url;
const $ = jQuery;
// const { Fragment } = wp.components;

import { ResultItem } from "./components/_result_item";
import { Pagination } from "./components/_pagination";
import { DateRange } from "./components/_date_range";
import { SearchTarget } from "./components/_search_target";
import { CheckFields } from "./components/_search_check_fields";
import { assignParams, searchWithParams } from "./components/_url";
import { Indicator } from "./components/_loading";

/* global PaidMediaSearchVars: false */

/**
 * Root component for search.
 */
class PaidMediaSearch extends Component {

  constructor( props ) {
    let state = assignParams( {
      active: 'simple',
      curPage: 1,
      totalPage: 0,
      total: 0,
      target: 'title',
      s: '',
      to: PaidMediaSearchVars.today,
      from: PaidMediaSearchVars.twoYearsAgo,
      industries: [],
      news_cats: [],
      post_types: [],
    } );
    state.isMember = true; // TODO: Detect premium member.
    state.searching = false;
    state.results = [];
    state.isAdvanced = !!PaidMediaSearchVars.advancedUser;
    state.placeholder = PaidMediaSearchVars.plceholder || 'キーワードを入力してください。';
    super( props );
    this.state = state;
    // Bind functions.
    this.toggleNav     = this.toggleNav.bind( this );
    this.setTarget     = this.setTarget.bind( this );
    this.setPagination = this.setPagination.bind( this );
    this.setRange      = this.setRange.bind( this );
    this.searchSubmit  = this.searchSubmit.bind( this );
    this.submit        = this.submit.bind( this );
    // set terms.
    this.industries = PaidMediaSearchVars.taxonomies.industry.terms.map( term => {
      return {
        id  : term.id,
        label: term.name
      }
    } );
    this.categories = PaidMediaSearchVars.taxonomies['news-cat'].terms.map( term => {
      return {
        id  : term.id,
        label: term.name
      }
    } );
    this.postTypes = PaidMediaSearchVars.post_types.map( postType => {
      return {
        id: postType.name,
        label: postType.label,
      }
    } );
  }

  /**
   * Toggle tab navigation.
   *
   * @param {MouseEvent} e
   */
  toggleNav( e ) {
    e.preventDefault();
    this.setState( { active: e.currentTarget.href.split( '#' )[1] } );
  }

  setTarget( target ) {
    this.setState( { target: target } );
  }

  setPagination( number ) {
    this.setState( { curPage: number }, () => this.submit( true ) );
  }

  setRange( range ) {
    this.setState( {
      from: range.from,
      to: range.to,
    } );
  }

  searchSubmit( target ) {
    this.setState( {
      curPage: 1
    }, () => this.submit( true ) );
  }

  submit( shouldRecord = true ) {
    if ( !this.state.isAdvanced && 'advanced' === this.state.target ) {
      return;
    }
    this.setState( {
      searching: true,
      totalPage: 0,
    }, () => {
      searchWithParams( this.state, shouldRecord ).then( ( response ) => {
        this.setState( {
          results: response.items,
          totalPage: response.total,
          total: response.totalItems,
        } );
      } ).catch( ( err ) => {
        this.setState( {
          results: [],
          total: 0,
          totalPage: 0,
        } );
      } ).finally( () => {
        this.setState( { searching: false }, () => {
          $( 'html,body' ).animate( {
            scrollTop: $( '#search-result-heading' ).offset().top
          } );
        } );
      });
    } );
  }

  componentDidMount() {
    if ( this.state.s ) {
      // Search current query.
      this.submit( false );
    }
  }

  render() {
    return (
      <Fragment>
        <ul className="nav nav-tabs" role="tablist">
          <li className="nav-item col p-0">
            <a className={`nav-link ${ 'simple' === this.state.active ? 'active' : '' }`} href="#simple"
              onClick={this.toggleNav}>
              シンプルな検索
            </a>
          </li>
          <li className="nav-item col p-0">
            <a className={`nav-link ${ 'advanced' === this.state.active ? 'active' : '' }`} href="#advanced"
              onClick={this.toggleNav}>
              高度な検索
            </a>
          </li>
        </ul>
        <div className='tab-content'>

          <div id="home" className={`container tab-pane ${ 'simple' === this.state.active ? 'active' : 'fade'}`}>
            <div className="row mt-4">
              <div className="col-md-5">
                <SearchTarget target={this.state.target} changeHandler={ this.setTarget }/>
              </div>
              <div className="col-md-7">
                <div className="form-group">
                  <label className="filter-label">キーワード</label>
                  <input type="text" value={this.state.s} className="form-control" placeholder={this.state.placeholder} onChange={(e) => this.setState({s: e.target.value})} />
                </div>
              </div>
              <div className="col-md-12 pt-3">


                <div className="row">
                  <label className="filter-label col-lg-2 py-2">掲載期間</label>
                  <div className="col-12">
                    <DateRange simple={true} to={this.state.to} from={this.state.from} rangeHandler={ this.setRange } />
                  </div>
                </div>

              </div>
              <div className="col-md-12 pt-3">
                <p className="alert-message">※シンプルな検索では最大2年間が対象です。</p>
              </div>
              <div className="col-lg-4 mx-auto my-4 actions">
                <button className="btn btn-custom btn-block search-box-btn" onClick={ this.searchSubmit } disabled={this.state.searching}>
                  Search
                </button>
              </div>
            </div>
          </div>


          <div id="menu1" className={`container tab-pane ${ 'advanced' === this.state.active ? 'active' : 'fade'}`}>
            <div className="row mt-4">
              <div className="col-md-12">
                <p className="alert-message mb-3">※特定プランのユーザのみご利用いただけます。</p>
              </div>
              <div className="col-md-5">
                <SearchTarget target={this.state.target} changeHandler={ this.setTarget } />
              </div>
              <div className="col-md-7">
                <div className="form-group field">
                  <label className="filter-label">キーワード</label>
                  <input type="text" name="s" value={this.state.s} className="form-control" placeholder={this.state.placeholder} onChange={(e) => this.setState( { s: e.target.value} ) } />
                </div>
              </div>
              <div className="col-md-12 pt-3">


                <div className="row">
                  <label className="filter-label col-lg-2 py-2">掲載期間</label>
                  <div className="col-12">
                    <DateRange simple={false} to={this.state.to} from={this.state.from} rangeHandler={ this.setRange } />
                  </div>
                </div>


                <div className="row pt-3">
                  <div className="col-lg-4 col-6">
                    <label className="filter-label">業種</label>
                    <CheckFields terms={this.industries} selectedIds={this.state.industries} handleChange={ ids => this.setState( { industries: ids } ) } />
                  </div>

                  <div className="col-lg-4 col-6">
                    <label className="filter-label">ジャンル</label>
                    <CheckFields terms={this.categories} selectedIds={this.state.news_cats} handleChange={ ids => this.setState( { news_cats: ids } ) } />
                  </div>

                  <div className="col-lg-4 col-6">
                    <label className="filter-label">新聞</label>
                    <CheckFields terms={this.postTypes} selectedIds={this.state.post_types} handleChange={ ids => this.setState( { post_types: ids } ) } />
                  </div>
                </div>
              </div>
              <div className="col-md-12 pt-3">
                <p className="alert-message">※特定プランのユーザのみご利用いただけます。</p>
              </div>
              <div className="col-lg-4 mx-auto my-4 actions">
                <button className="btn btn-custom btn-block search-box-btn" disabled={ this.state.searching || ! this.state.isAdvanced } onClick={ this.searchSubmit }>
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 p-0">
          <div className="heading-section" id='search-result-heading'>
            <h1 className="news-section-title">{ ( this.state.s && 0 < this.state.totalPage ) ? (
              <span>「{this.state.s}」の検索結果 <strong>全{this.state.total}件</strong>（{this.state.curPage} / {this.state.totalPage} ページ）を表示しています。</span>
              ) : '検索するキーワードを入れてください。' }
            </h1>
          </div>
        </div>

        <div style={ { position: 'relative', minHeight: '300px' } }>
          <ResultItem items={this.state.results}/>
          <Pagination current={this.state.curPage} total={this.state.totalPage} onNumberChange={ this.setPagination } />
          <Indicator loading={this.state.searching}/>
        </div>

      </Fragment>
    )
  }
}

render( <PaidMediaSearch/>, document.getElementById( 'newspaper-search' ) );
